import { Observable } from '../utils/Observable';

export interface TimelineState {
  currentDecade: number;
  playing: boolean;
  speed: 1 | 2 | 5;
  minDecade: number;
  maxDecade: number;
}

const INITIAL_TIMELINE_STATE: TimelineState = {
  currentDecade: 1800,
  playing: false,
  speed: 1,
  minDecade: 1600,
  maxDecade: 2000,
};

export const TimelineStore = new Observable<TimelineState>(INITIAL_TIMELINE_STATE);
